<template>
    <ul class="servicesPlanItems">
        <li v-for="item in ServicesViewData" :key="item.title  + Math.random()">
            <div class="img_list_plans">
                <img src="@/assets/images/serveis_img_smm.svg" alt="">
            </div>
            <h4>{{item.title}}</h4>
            <p>{{item.longText}}</p>
            <div>
                <input id="checkbox" type="checkbox">
                <label>{{item.labelText}}</label>
                <input id="checkbox2" type="checkbox">
                <label>{{item.labelText}}</label>
                <input id="checkbox3" type="checkbox">
                <label>{{item.labelText}}</label>
                <input id="checkbox4" type="checkbox">
                <label>{{item.labelText}}</label>
                <input id="checkbox5" type="checkbox">
                <label>{{item.labelText}}</label>
            </div>
            <h6>{{item.price}}</h6>
            <span>{{item.spanText}}</span>
            <button class="button_summbit">ORDER NOW</button>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "ServicesViewCompontent",
        props: ['ServicesViewData'],
    }
</script>

<style lang="scss" scoped>
    .servicesPlanItems {
        -webkit-animation: animation_open 1s;
        animation: animation_open 1s;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-left: -24.5px;
        width: 1420px !important;
        margin-top: 20px;

        li {
            width: 425px;
            text-align: center;
            margin: 15px 23px;
            padding: 15px;
            -webkit-box-shadow: 0px 0px 15px 5px rgba(126, 126, 126, 0.101961);
            box-shadow: 0px 0px 15px 5px rgba(126, 126, 126, 0.101961);

            h4 {
                font-size: 24px;
                padding: 5px;
                text-align: center;
                font-weight: 500;
                color: #000;
                margin: 22px 20px;
                margin-bottom: 0px;
            }

            p {
                padding: 5px;
                font-size: 16px;
                color: #c9c9c9;
                line-height: 1.5;
                width: 83%;
                margin: 0 auto;
                margin-bottom: 20px;
                margin-top: 0px;
            }

            div {
                padding: 10px;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-orient: vertical;
                -webkit-box-direction: normal;
                -ms-flex-direction: column;
                flex-direction: column;
                width: 85%;
                margin: 0 auto;
                margin-top: -20px;

                label {
                    padding: 0;
                    margin: 0;
                    margin-top: -15px;
                    color: #8a8a8a;
                    font-size: 16px;
                    margin-left: 37px;
                }

                input {
                    width: 15px;
                    height: 15px;
                    padding: 0px;
                    margin: 0;
                    margin-top: 22.5px;
                    margin-left: 9px;

                }
            }

            .img_list_plans {
                margin-top: 25px;
                background-color: #49d6cb;
                border-radius: 50%;
                display: inline-block;
                width: 91px;
                height: 91px;

                img {
                    margin-left: 15%;
                    margin-top: 20%;
                }
            }

            h6 {
                font-size: 32px;
                color: #00a49a;
                font-weight: 500;
                margin: 30px 0 10px 0;
            }
        }

        span {
            color: #c9c9c9;
            font-size: 12px;
            margin: 0 auto;
            display: block;
        }

        button {
            background-color: #49d6cb;
            color: #fff;
            font-size: 16px;
            border: none;
            border-radius: 10px;
            padding: 17px 50px;
            margin: 28px;
            margin-left: 52px;
            transition: all 0.5s;
            border: 1px solid #49d6cb;
        }

        button:hover {
            background-color: #fff;
            color: #49d6cb;

        }

    }

    @media only screen and (max-width: 1500px) {
        .servicesPlanItems {
            -webkit-animation: animation_open 1s;
            animation: animation_open 1s;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            justify-content: flex-start;
            margin-left: -24.5px;
            width: 1300px !important;
            margin-top: 20px;

            li {
                width: 380px;
                text-align: center;
                margin: 15px 20px;
                padding: 15px;
                -webkit-box-shadow: 0px 0px 15px 5px rgba(126, 126, 126, 0.101961);
                box-shadow: 0px 0px 15px 5px rgba(126, 126, 126, 0.101961);

                h4 {
                    font-size: 24px;
                    padding: 5px;
                    text-align: center;
                    font-weight: 500;
                    color: #000;
                    margin: 22px 20px;
                    margin-bottom: 0px;
                }

                p {
                    padding: 5px;
                    font-size: 16px;
                    color: #c9c9c9;
                    line-height: 1.5;
                    width: 83%;
                    margin: 0 auto;
                    margin-bottom: 20px;
                    margin-top: 0px;
                }

                div {
                    padding: 10px;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -ms-flex-direction: column;
                    flex-direction: column;
                    width: 85%;
                    margin: 0 auto;
                    margin-top: -20px;

                    label {
                        padding: 0;
                        margin: 0;
                        margin-top: -15px;
                        color: #8a8a8a;
                        font-size: 16px;
                        margin-left: 37px;
                    }

                    input {
                        width: 15px;
                        height: 15px;
                        padding: 0px;
                        margin: 0;
                        margin-top: 22.5px;
                        margin-left: 9px;

                    }
                }

                .img_list_plans {
                    margin-top: 25px;
                    background-color: #49d6cb;
                    border-radius: 50%;
                    display: inline-block;
                    width: 91px;
                    height: 91px;

                    img {
                        margin-left: 15%;
                        margin-top: 20%;
                    }
                }

                h6 {
                    font-size: 32px;
                    color: #00a49a;
                    font-weight: 500;
                    margin: 30px 0 10px 0;
                }
            }

            span {
                color: #c9c9c9;
                font-size: 12px;
                margin: 0 auto;
                display: block;
            }

            button {
                background-color: #49d6cb;
                color: #fff;
                font-size: 16px;
                border: none;
                border-radius: 10px;
                padding: 17px 50px;
                margin: 28px;
                margin-left: 52px;
                transition: all 0.5s;
                border: 1px solid #49d6cb;
            }

            button:hover {
                background-color: #fff;
                color: #49d6cb;

            }

        }
    }
    @media only screen and (max-width: 1370px) {
        .servicesPlanItems {
            -webkit-animation: animation_open 1s;
            animation: animation_open 1s;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            justify-content: center;
            margin-left: -24.5px;
            width: 100% !important;
            margin-top: 20px;

            li {
                width: 425px;
                text-align: center;
                margin: 15px 20px;
                padding: 15px;
                -webkit-box-shadow: 0px 0px 15px 5px rgba(126, 126, 126, 0.101961);
                box-shadow: 0px 0px 15px 5px rgba(126, 126, 126, 0.101961);

                h4 {
                    font-size: 24px;
                    padding: 5px;
                    text-align: center;
                    font-weight: 500;
                    color: #000;
                    margin: 22px 20px;
                    margin-bottom: 0px;
                }

                p {
                    padding: 5px;
                    font-size: 16px;
                    color: #c9c9c9;
                    line-height: 1.5;
                    width: 83%;
                    margin: 0 auto;
                    margin-bottom: 20px;
                    margin-top: 0px;
                }

                div {
                    padding: 10px;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -ms-flex-direction: column;
                    flex-direction: column;
                    width: 85%;
                    margin: 0 auto;
                    margin-top: -20px;

                    label {
                        padding: 0;
                        margin: 0;
                        margin-top: -15px;
                        color: #8a8a8a;
                        font-size: 16px;
                        margin-left: 37px;
                    }

                    input {
                        width: 15px;
                        height: 15px;
                        padding: 0px;
                        margin: 0;
                        margin-top: 22.5px;
                        margin-left: 9px;

                    }
                }

                .img_list_plans {
                    margin-top: 25px;
                    background-color: #49d6cb;
                    border-radius: 50%;
                    display: inline-block;
                    width: 91px;
                    height: 91px;

                    img {
                        margin-left: 15%;
                        margin-top: 20%;
                    }
                }

                h6 {
                    font-size: 32px;
                    color: #00a49a;
                    font-weight: 500;
                    margin: 30px 0 10px 0;
                }
            }

            span {
                color: #c9c9c9;
                font-size: 12px;
                margin: 0 auto;
                display: block;
            }

            button {
                background-color: #49d6cb;
                color: #fff;
                font-size: 16px;
                border: none;
                border-radius: 10px;
                padding: 17px 50px;
                margin: 28px;
                margin-left: 52px;
                transition: all 0.5s;
                border: 1px solid #49d6cb;
            }

            button:hover {
                background-color: #fff;
                color: #49d6cb;

            }

        }
    }
    @media only screen and (max-width: 980px) {
        .servicesPlanItems {
            padding: 0;
            margin: 0;
            -webkit-animation: animation_open 1s;
            animation: animation_open 1s;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            justify-content: center;
            margin-left: -24.5px;
            width: 100% !important;
            margin-top: 20px;
            margin: 0 auto;
            li {
                width: 350px;
                text-align: center;
                margin: 15px 20px;
                padding: 15px;
                -webkit-box-shadow: 0px 0px 15px 5px rgba(126, 126, 126, 0.101961);
                box-shadow: 0px 0px 15px 5px rgba(126, 126, 126, 0.101961);

                h4 {
                    font-size: 22px;
                    padding: 5px;
                    text-align: center;
                    font-weight: 500;
                    color: #000;
                    margin: 22px 20px;
                    margin-bottom: 0px;
                }

                p {
                    padding: 5px;
                    font-size: 12px;
                    color: #c9c9c9;
                    line-height: 1.5;
                    width: 83%;
                    margin: 0 auto;
                    margin-bottom: 20px;
                    margin-top: 0px;
                }

                div {
                    padding: 0px;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -ms-flex-direction: column;
                    flex-direction: column;
                    width: 90%;
                    margin: 0 auto;
                    margin-top: -20px;

                    label {
                        padding: 0;
                        margin: 0;
                        margin-top: -15px;
                        color: #8a8a8a;
                        font-size: 14px;
                        margin-left: 20px;
                    }

                    input {
                        width: 15px;
                        height: 15px;
                        padding: 0px;
                        margin: 0;
                        margin-top: 22.5px;
                        margin-left: 9px;

                    }
                }

                .img_list_plans {
                    margin-top: 25px;
                    background-color: #49d6cb;
                    border-radius: 50%;
                    display: inline-block;
                    width: 91px;
                    height: 91px;

                    img {
                        margin-left: 15%;
                        margin-top: 20%;
                    }
                }

                h6 {
                    font-size: 32px;
                    color: #00a49a;
                    font-weight: 500;
                    margin: 30px 0 10px 0;
                }
            }

            span {
                color: #c9c9c9;
                font-size: 12px;
                margin: 0 auto;
                display: block;
            }

            button {
                background-color: #49d6cb;
                color: #fff;
                font-size: 16px;
                border: none;
                border-radius: 10px;
                padding: 17px 50px;
                margin: 28px;
                margin-left: 52px;
                transition: all 0.5s;
                border: 1px solid #49d6cb;
            }

            button:hover {
                background-color: #fff;
                color: #49d6cb;

            }

        }
    }
    @media only screen and (max-width: 460px) {
        .servicesPlanItems {
            padding: 0;
            margin: 0;
            -webkit-animation: animation_open 1s;
            animation: animation_open 1s;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            justify-content: center;
            margin-left: -24.5px;
            width: 100% !important;
            margin-top: 20px;
            margin: 0 auto;
            li {
                width: 350px;
                text-align: center;
                margin: 5px 10px;
                padding: 5px;
                -webkit-box-shadow: 0px 0px 15px 5px rgba(126, 126, 126, 0.101961);
                box-shadow: 0px 0px 15px 5px rgba(126, 126, 126, 0.101961);

                h4 {
                    font-size: 22px;
                    padding: 5px;
                    text-align: center;
                    font-weight: 500;
                    color: #000;
                    margin: 22px 20px;
                    margin-bottom: 0px;
                }

                p {
                    padding: 5px;
                    font-size: 12px;
                    color: #c9c9c9;
                    line-height: 1.5;
                    width: 83%;
                    margin: 0 auto;
                    margin-bottom: 20px;
                    margin-top: 0px;
                }

                div {
                    padding: 0px;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -ms-flex-direction: column;
                    flex-direction: column;
                    width: 90%;
                    margin: 0 auto;
                    margin-top: -20px;

                    label {
                        padding: 0;
                        margin: 0;
                        margin-top: -15px;
                        color: #8a8a8a;
                        font-size: 12px;
                        margin-left: 20px;
                    }

                    input {
                        width: 15px;
                        height: 15px;
                        padding: 0px;
                        margin: 0;
                        margin-top: 22.5px;
                        margin-left: 9px;
                    }
                }

                .img_list_plans {
                    margin-top: 25px;
                    background-color: #49d6cb;
                    border-radius: 50%;
                    display: inline-block;
                    width: 91px;
                    height: 91px;

                    img {
                        margin-left: 15%;
                        margin-top: 20%;
                    }
                }

                h6 {
                    font-size: 25px;
                    color: #00a49a;
                    font-weight: 500;
                    margin: 30px 0 10px 0;
                }
            }

            span {
                color: #c9c9c9;
                font-size: 10px;
                margin: 0 auto;
                display: block;
            }

            button {
                background-color: #49d6cb;
                color: #fff;
                font-size: 16px;
                border: none;
                border-radius: 10px;
                padding: 17px 40px;
                margin: 28px;
                margin-left: 52px;
                transition: all 0.5s;
                border: 1px solid #49d6cb;
            }

            button:hover {
                background-color: #fff;
                color: #49d6cb;

            }

        }
    }
</style>